// extracted by css-extract-rspack-plugin
export default {"text":"QuestionTitle-module__text___UMyxm","title":"QuestionTitle-module__title___hY2p0"};